import { render } from "./BillJournalEntry.vue?vue&type=template&id=fde80528"
import script from "./BillJournalEntry.vue?vue&type=script&lang=js"
export * from "./BillJournalEntry.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__